export default __webpack_public_path__ + "static/media/micro.5741c239.webp";